export const STREAM_SNOOZE_DURATION = 60; // seconds
export const MAX_ACTIVE_STREAMS = 5;
export const ALARM_COUNT_REQUEST_INTERVAL = 7000; // 7 seconds
export const ALARM_REQUEST_INTERVAL = 5000; // 5 seconds
